import { CircularProgress, Stack, Typography } from "@mui/joy";
import NewcomerButton from "components/user/NewcomerButton";
import LoginButton from "components/user/LoginButton";
import useIsInappWebview from "hooks/useIsInappWebview";
import useMixpanelWeb from "hooks/useMixpanelWeb";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import DefaultPage from "./DefaultPage2";
import { useTranslation } from "react-i18next";
import AppleLoginButton from "components/user/AppleLoginButton";
import GoogleLoginButton from "components/user/GoogleLoginButton";
import useDetectIOS from "hooks/useDetectIOS";
import { isBrowser } from "react-device-detect";
import { isDev } from "config";
import { permanentDataAtom } from "recoil/permanentDataAtom";

export default function Login() {
  let navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const permanantDataState = useRecoilValue(permanentDataAtom);
  const { isIOS } = useDetectIOS();
  const isInappWebview = useIsInappWebview();

  const { t: t_ui } = useTranslation("translation", {
    keyPrefix: "ui",
  });

  const [searchParams] = useSearchParams();
  const { state } = useLocation();

  const isOnboarding = searchParams.get("type") === "1"; //신규모객

  useEffect(() => {
    if (!user || !user?.accessToken) {
      if (isOnboarding) {
        setMixPanel_new();
        navigate("/", { replace: true, state: { isOnboarding: true } });
      }
    } else {
      navigate("/", { ...state, replace: true });
    }
  }, [user]);

  const setMixPanel_new = useMixpanelWeb({
    eventName: "0-0-A로 바로 진입",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const showBothLoginButton = isIOS
    ? (permanantDataState?.appVersion || "1.0.0") >= "1.0.12"
    : true;

  return (
    <DefaultPage
      content={
        !isLoading ? (
          <Stack spacing={"40px"} sx={{ width: "100%" }}>
            <Stack spacing={"30px"} sx={{ textAlign: "center" }}>
              <Typography level="h1">
                {t_ui("생각과 거리두고\n가치로 나아가세요")}
              </Typography>
              <Typography level={"title-lg"} sx={{ opacity: 0.5 }}>
                {t_ui(
                  "안전하고 효과적인 비약물 인지치료,\n정신건강 전문 코치들이 이끕니다."
                )}
              </Typography>
            </Stack>

            <Stack
              spacing={1}
              sx={{
                width: "100%",
                maxWidth: "500px",
              }}
              alignSelf="center"
            >
              {/* <NewcomerButton /> */}
              {/* <LoginButton /> */}
              {(!isInappWebview || isIOS || showBothLoginButton) && (
                <AppleLoginButton />
              )}
              {(!isInappWebview || !isIOS || showBothLoginButton) && (
                <GoogleLoginButton />
              )}
            </Stack>
          </Stack>
        ) : (
          <Stack alignItems={"center"}>
            <CircularProgress color="neutral" />
          </Stack>
        )
      }
    />
  );
}
